type Classroom = {
  id: string;
  name: string;
  courseId: string;
  courseName: string;
  courseOrder: number;
  icon: number;
  avatar: string | null;
  level?: string;
  providerId?: string | null;
  provider?: string | null;
  providerChecked?: boolean | null;
  checked?: boolean;
  numberOfStudents?: number;
  teachersNames?: string[];
  type: ClassroomType;
};

const CLASSROOM_TYPE = {
  CLASSROOM: 'CORE',
  JOURNEYS: 'JOURNEYS',
} as const;

const DEFAULT_COURSE_ORDER_FOR_GROUPS = 6;

type ClassroomType = (typeof CLASSROOM_TYPE)[keyof typeof CLASSROOM_TYPE];

export { CLASSROOM_TYPE, DEFAULT_COURSE_ORDER_FOR_GROUPS };
export type { Classroom, ClassroomType };
